import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CacheService {
  public currentUserDetails = null;
  public resetAppCache$ = new BehaviorSubject(false);

  resetUserStuff() {
    this.currentUserDetails = null;
  }

  resetAppCache() {
    this.resetAppCache$.next(true);
  }

  resetAll() {
    this.resetUserStuff();
    this.resetAppCache();
  }

  buildCacheSkipHeader(skip: boolean) {
    return {
      'APP-CACHE-SKIP': skip ?
        'true' :
        'false',
    };
  }
}
